module.exports = __webpack_public_path__ + "img/fiat-smartrace-autoshow-04.7e4108fa.jpg";